import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import GetSvgIcon from "../../../assets/images/svgList";
import FormButton from "../../../Components/Buttons/FormButton";
import CustomDropdown from "../../../Components/Dropdown/CustomDropdown";
import FormSelect from "../../../Components/FormTag/FormSelect";
import InputFiled from "../../../Components/FormTag/InputFiled";
import TimerWithPausePlay from "../../../Layout/Timer";
import { captializeString } from "../../../Utility/Utility";
import { getData } from "./Service/InventoryServices";

const AdjustmentCreate: React.FC = () => {
  const [layout, setLayout] = useState<any>(null);
  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [valueChecker, setValueChecker] = useState({
    error: false,
    errorMessage: ""
  })
  const [textValue, setTextValue] = useState<string>("")
  const [showSuccessLogo, setShowSuccessLogo] = useState(false);
  const currentFieldIndex = 0;
  const navigation = useNavigate();
  const { control, register, setValue } = useForm({
    defaultValues: {},
  });
  const API_BASE_URL = "/apijson";

  const handleAction = (action: string) => {

    if (action === "handleCancelBtn") {
      navigation("/inventory/inventory-adjustment");
    } else if (action === "handleSaveBtn") {
      setShowSuccessLogo(true);
      setTimeout(() => {
        navigation("/inventory/inventory-adjustment");
      }, 2000);
    } else {
      console.error(`Unhandled action type: ${action}`);
    }
  };

  const handleFieldChange = (fieldName: string, value: any) => {
    if (!value) {
      if (!valueChecker.errorMessage) {
        setValueChecker({
          error: false,
          errorMessage: `Please enter a value for ${fieldName}`,
        });
      }
    } else {
      setFormData({ ...formData, [fieldName]: value });
      setValueChecker({
        error: true,
        errorMessage: "",
      });
    }
  };

  const handleScanIconClick = (apiEndpoint: string, fieldName: string) => {
    // if (!valueChecker.error) {
    //   if (!valueChecker.errorMessage) {
    //     setValueChecker({
    //       error: false,
    //       errorMessage: `Please enter valid ${captializeString(fieldName)}`,
    //     });
    //   }
    //   return;
    // }


    getData(`${API_BASE_URL}${apiEndpoint}`).then((response) => {
      const layout = response.data.data.layout;
      if (layout && layout.body?.left?.scanPanel?.fields) {
        setLayout(layout);
        setValueChecker((prevState) => ({
          ...prevState,
          error: false,
          errorMessage: "",
        }));
        setTextValue("");
      } else {
        console.error("Invalid API response format:", response.data);
      }
    })
      .catch((error) => {
        console.error(`Error ${apiEndpoint}: `, error);
      });
  };

  // Fetch initial layout data from API
  useEffect(() => {
    getData(`${API_BASE_URL}/dynamicFormScreen.json`).then((response) => {
      setLayout(response.data.data.layout);
    })
      .catch((error) => {
        console.error("Error: ", error);
      });
  }, []);

  if (!layout) {
    return <div>Loading...</div>;
  }

  const scanPanelFields = layout.body.left.scanPanel.fields;
  const adjustmentSummary = layout.body.left.adjustmentSummary.fields;
  const successMessage = layout.body.left.successMessage;

  return (
    <div>
      <div className="d-flex flex-column h-100 min-h-85">
        {/* Header */}
        <div className="d-flex justify-content-start mt-3 gap-2">
          {layout.header.fields.map((field: any, i: number) => (
            <div key={i} className="col">
              <div className="top-tab p-3">
                <div>
                  <strong>{field.label}</strong> {field.value || "-"}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Main Body */}
        <div className="d-flex justify-content-between my-3">
          {/* Left Section: Scan Panel */}
          <div className="col-5 d-flex flex-column justify-content-between scanning-area">
            <div className="d-flex align-items-center justify-content-around scanning-area-top">
              {scanPanelFields[currentFieldIndex]?.title || "Start Scanning"}
            </div>

            <div className="bg-white p-4 scanning-area-bottom">
              {(() => {
                const field = scanPanelFields[currentFieldIndex];
                if (!field) return null;
                return (
                  <div className="d-flex align-items-center gap-2">
                    <div className="input-group scanner-input-group">
                      {field.type === "text" && (
                        <InputFiled
                          type="text"
                          name={field.name}
                          className={`p-0 form-control rounded-start-pill  border-end-0 p-3  ${field.scan_icon
                            ? "scanner-input"
                            : "scanner-input-text"
                            } ${valueChecker.errorMessage
                              ? !field.scan_icon
                                ? "scanner-input-error-text"
                                : "scanner-input-error"
                              : "scanner-input"
                            }`}
                          placeholder={field.placeholder}
                          tabIndex={4}
                          register={register}
                          value={textValue}
                          onChange={(e: any) => {

                            handleFieldChange(field.name, e.target.value)
                            setTextValue(e.target.value)
                          }
                          }
                        />
                      )}
                      {field.type === "customdropdown" && (
                        <CustomDropdown
                          customClassName={`custom-dropdown-adjustment-container p-0 border-0 form-control rounded-start-pill border border-info border-end-0 p-3 scanner-custom-dropdown ${valueChecker.errorMessage
                            ? "scanner-input-error"
                            : "scanner-input"
                            }`}
                          data={
                            Array.isArray(field.options) ? field.options : []
                          }
                          handleSelect={(selectedOption) => {

                            handleFieldChange(field.name, selectedOption.Item || selectedOption['Reason Code'])
                          }
                          }
                          selectableColumns={Object.keys(field.options?.[0] || {}).map((key) => ({
                            columnName: key.charAt(0).toUpperCase() + key.slice(1),
                            selector: key,
                          }))}
                          placeholder={field.placeholder}
                          name={field.name}
                        />
                      )}
                      {field.type === "dropdown" && (
                        <FormSelect
                          name={field.name}
                          control={control}
                          optionList={field.options}
                          required={true}
                          classNamePrefix="scanner"
                          className={`no-border-dropdown border-none p-0 form-control rounded-start-pill border-end-0 p-3 custom-dropdown-container scanner-dropdown ${valueChecker.errorMessage
                            ? "scanner-input-error"
                            : "scanner-input"
                            }`}
                          placeholder={field.placeholder}
                          isSearchable={true}
                          onChange={(selectedOption) => {
                            handleFieldChange(field.name, selectedOption.value);
                          }}
                          defaultValue={null}
                          label={field.label}
                        />
                      )}

                      {field.search_icon && (
                        <span
                          className={`${valueChecker.errorMessage
                            ? "border-danger"
                            : "border-info"
                            } input-group-text bg-white border border-start-0 cursor-pointer ${field.scan_icon ? "" : "rounded-end-pill"
                            } ${valueChecker.errorMessage
                              ? "border-danger"
                              : "border-info"
                            }`}
                          onClick={() =>
                            handleScanIconClick(field.next_url, field.name)
                          }
                        >
                          {GetSvgIcon.GlobalSearchIcon}
                        </span>
                      )}
                      {field.scan_icon && (
                        <span
                          className={`${valueChecker.errorMessage
                            ? "border-danger"
                            : "border-info"
                            } input-group-text  rounded-end-pill bg-white border border-start-0 cursor-pointer`}
                          onClick={() =>
                            handleScanIconClick(field.next_url, field.name)
                          }
                        >
                          {GetSvgIcon.UpcScanner}
                        </span>
                      )}
                    </div>
                    {field.enter_icon && (
                      <span
                        className="input-group-text bg-white cursor-pointer scanner-enter-icon"
                        onClick={() =>
                          handleScanIconClick(field.next_url, field.name)
                        }
                      >
                        {GetSvgIcon.ArrowReturnLeft}
                      </span>
                    )}
                  </div>
                );
              })()}
              <small className="ms-4 text-danger">
                {valueChecker.errorMessage}
              </small>
            </div>

            {/* Adjustment Summary */}
            <div className="d-flex justify-content-between mt-2 gap-2">
              {adjustmentSummary.map((field: any, index: number) => (
                <div key={index} className="col">
                  <div className="top-tab p-3 d-flex justify-content-between">
                    <div>
                      <strong>{field.label}</strong>
                    </div>
                    {field.label === "Qty Adjusted:" ? (
                      <div className="d-flex align-items-center gap-3">
                        <div>{formData[field.label] || ""}</div>
                        {GetSvgIcon.RoundIcon}
                        <strong className="ml-2">{field.value}</strong>
                      </div>
                    ) : (
                      <div>
                        <strong>{field.value}</strong>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {showSuccessLogo && (
              <div className="white-body d-flex justify-content-center align-items-center mt-2">
                <div>
                  <div className="mt-5 d-flex justify-content-center">
                    {GetSvgIcon.ScannerSuccessLogo}
                  </div>
                  <div className="col-12 mt-3 mb-5">
                    <strong>{successMessage}</strong>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Right Section: Items List */}
          <div className="col-7 ms-2">
            <div className="top-tab h-100 p-2">
              <div className="table-header d-flex mx-5 fw-bold row px-0 mt-3">
                {layout.body.right.itemsList.columns.map(
                  (col: any, i: number) => (
                    <div key={i} className="col-4">
                      <label>{col.label}</label>
                    </div>
                  )
                )}
              </div>
              <div className="row d-flex mx-5 mt-3 align-items-center border-bottom pb-3">
                {layout.body.right.itemsList.data.map((item: any, i: number) => (
                  <div key={i} className="d-flex w-100">
                    {/* Left Section - Image and Text */}
                    <div className="col-4 d-flex align-items-center">
                      <img
                        src={require(`../../../assets/images/phone1.jpg`)}
                        style={{ width: "40px", marginRight: "8px" }}
                      />
                      <div className="d-flex flex-column">
                        <label className="fw-bold">{item.itemName.text}</label>
                        <label>{item.itemName.code}</label>
                      </div>
                    </div>
                    <div className="col-4 d-flex flex-column">
                      <label className="ps-2">{item.uom}</label>
                      <label>{item.ua}</label>
                    </div>
                    <div className="col-4 ps-3">{formData["Qty Adjusted"] || item.adjustedQty}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="row mt-auto">
          <div className="col-12 d-flex">
            {/* Left Section: Scan Panel */}
            <div className="col-5 d-flex ">
              <TimerWithPausePlay />
            </div>
            {/* Right Section: Button Actions */}
            <div className="col-7 ms-2">
              {successMessage && (
                <div className="mt-2 bg-white rounded py-3 mt-auto col">
                  <div className="d-flex flex-row-reverse">
                    {layout.footer.fields.map((field: any, i: number) => (
                      <FormButton
                        key={i}
                        className={`sph-btn ${field.text == "Cancel" ? "sph-shift" : ""
                          } me-4`}
                        handleClick={() => handleAction(field.action)}
                      >
                        {field.text}
                      </FormButton>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdjustmentCreate;
